import * as React from "react";

function SvgFunnelEnvy(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 109 113"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M94.1 97.3c-1.2-11.9-3.8-22.5-7.2-32-2.1 2.5-4.5 4.9-7.2 7.2 6.6 9.9 9.9 19.3 11.5 27.1l2.9-2.3zM53.5 13.8L31.1 31.4c1.6.9 3.2 1.9 4.9 2.8 14.5 7.9 25.3 16.5 33.4 25 4.4-3.8 7.6-7.8 9.8-11.7-8.3-15.6-18.3-26.8-25.7-33.7z"
        fill="#35aadb"
      />
      <path
        d="M30.4 58.7c-.5 4.5.3 8.5 2.7 11.6 7 8.6 24.8 6 39-5.7s20.2-28.8 13.3-37.4c-3.5-4.4-9.9-5.8-17.2-4.7-1.2-1.5-2.5-2.9-3.7-4.3 9.8-2.1 18.7-.1 24 6.4 9 11.1 3.1 30.3-13.3 43.8C58.9 82 39 83.9 30 72.9c-3.4-4.2-4.7-9.6-4-15.4 1.5.3 3 .8 4.4 1.2z"
        fill="#f9a61a"
      />
      <path d="M27 40.4c-1.6-.7-3.1-1.4-4.6-2.1L10.1 48c3.2.9 6.5 1.8 10 2.5 16.1 3.6 28.6 9.3 38.3 15.9 1.7-.8 3.3-1.7 5-2.8-8.9-8.2-20.7-16.3-36.4-23.2zm47.6 35.9c-.9.6-1.8 1.2-2.7 1.7 4.6 4.9 8.2 9.9 10.9 14.7l.8-.9c-2.1-4.9-5-10.1-9-15.5z" />
    </svg>
  );
}

export default React.forwardRef(SvgFunnelEnvy);
